import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
var useStyles = makeStyles(function (theme) {
  var _root;

  return {
    root: (_root = {
      display: 'grid',
      gridColumnGap: theme.spacing(2),
      gridRowGap: theme.spacing(2),
      justifyItems: 'stretch',
      alignItems: 'stretch',
      justifyContent: 'stretch',
      gridTemplateColumns: '40% 1fr .5fr',
      gridTemplateRows: 'auto auto auto auto auto auto auto auto auto',
      gridTemplateAreas: "\n        'image        name              actions'\n        'image        rating            rating'\n        'image        description       description'\n        'image        price             addToCart'\n        'image        stockInfo         stockInfo'\n        'image        customImageAside  customImageAside'\n        'customMiddle customMiddle      customMiddle'\n        'parameters   parameters        parameters'\n      "
    }, _defineProperty(_root, theme.breakpoints.up('xl'), {
      gridTemplateColumns: '1fr 1fr .5fr'
    }), _defineProperty(_root, theme.breakpoints.down('sm'), {
      gridTemplateColumns: '1fr 1fr .5fr',
      gridTemplateRows: '64px 350px auto 64px auto auto auto auto auto auto',
      gridTemplateAreas: "\n          'name             name              actions'\n          'image            image             image'\n          'rating           rating            rating'\n          'price            addToCart         addToCart'\n          'stockInfo        stockInfo         stockInfo'\n          'description      description       description'\n          'customImageAside customImageAside  customImageAside'\n          'customMiddle     customMiddle      customMiddle'\n          'parameters       parameters        parameters'\n        ",
      gridColumnGap: theme.spacing(1),
      gridRowGap: theme.spacing(1)
    }), _defineProperty(_root, theme.breakpoints.down('xs'), {
      gridTemplateAreas: "\n          \"name             name              actions\"\n          \"image            image             image\"\n          \"rating           rating            rating\"\n          \"price            addToCart         addToCart\"\n          \"stockInfo        stockInfo         stockInfo\"\n          \"description      description       description\"\n          \"customImageAside customImageAside  customImageAside\"\n          \"customMiddle     customMiddle      customMiddle\"\n          \"parameters       parameters        parameters\"\n        ",
      alignItems: 'center',
      justifyItems: 'center',
      gridTemplateRows: '56px auto auto auto auto auto auto auto auto'
    }), _root)
  };
}, {
  name: 'SxComProductDetail'
});

function ProductDetail(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), children);
}

ProductDetail.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string
};
ProductDetail.defaultProps = {
  children: null,
  classes: undefined,
  className: undefined
};
export default ProductDetail;